// src/redux/stockerSignal/stockerSignalActionThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import stockerSignalAPI from "./stockerSignalAPI";

// Fetch composite signal for a ticker
export const fetchStockerSignal = createAsyncThunk(
  "stockerSignal/fetchStockerSignal",
  async ({ ticker, window = "30d" }, { rejectWithValue }) => {
    try {
      const data = await stockerSignalAPI.getStockerSignal(ticker, window);
      return { ticker, data };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to load Stocker Signal");
    }
  }
);
